import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { builderHeroData } from './builderHeroData'
import { BuilderHeroCard } from './BuilderHeroCard'
import OpenAiIcon from './icon-open-ai.svg'
import classes from './BuilderHero.module.scss'

export const BuilderHero = () => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <Block
        variant={'solidMob'}
        r={'md'}
        pad={'baseMob'}
        className={classes.content}
      >
        <Heading
          as={'h1'}
          size={'xxl'}
          center
          balance
          className={classes.title}
        >
          Turn any app's API into <wbr /> a&nbsp;connector using LLMs
        </Heading>
        <Heading
          as={'h2'}
          size={'xxl'}
          center
          balance
          className={classes.subtitle}
        >
          #1 Connector Builder tool <wbr /> in the market
        </Heading>
        <ul className={classes.list}>
          {builderHeroData.map((item, idx) => (
            <BuilderHeroCard key={idx} item={item} />
          ))}
        </ul>

        <div className={classes.note}>
          <Text as={'span'} size={'lg'} className={classes.description__light}>
            Powered by
          </Text>
          <img width={99} height={24} src={OpenAiIcon.src} alt='Open AI Icon' />
        </div>
      </Block>
    </Block>
  )
}
